import { VISIT_INVENTORY_APP } from './constants/policies'

export default {
  name: 'Inventory Check',
  shortName: 'Inventory\nCheck',
  icon: 'fas fa-barcode',
  description: 'Simple Inventory Check.',
  accessors: ['inventory-manager'],
  ns: 'SimpleInventoryCheckNS',
  policy: VISIT_INVENTORY_APP,
  isMoveToNewSite: false,
  document: 'https://docs.google.com/document/d/1_JfYBEXPCCXGhM5b6ncuAME5ecGAfXaGbYyqTgggvFk/edit?usp=sharing'
}
